import { queryOptions, useQuery } from '@tanstack/react-query';

import { dictionaryApi } from '../api/dictionary-api';

import { dictionaryKeys } from './dictionary-keys';

/** Ring size, engraving and the like; products reference them by id. */
export function customizationsQueryOptions() {
  return queryOptions({
    queryKey: dictionaryKeys.customizations(),
    queryFn: dictionaryApi.listCustomizations,
    staleTime: 5 * 60_000,
  });
}

export function useCustomizations() {
  return useQuery(customizationsQueryOptions());
}
